import { ReactNode } from "react";
import { Button, ButtonVariations } from "../buttons/button";

export const EmptyState = ({
  image = (
    <img src={"/assets/images/empty_state_coming_soon.svg"} alt="empty" />
  ),
  title,
  titleClassName = "",
  subtitle,
  subtitleClassName,
  actionText = "",
  onClick = () => {},
  actionButtonVariant = "primary",
  actionDisabled = false,
  buttonContainerClassName = "",
  imageClassName = "",
  className = "",
}: {
  image?: ReactNode;
  title: string;
  titleClassName?: string;
  subtitle?: string;
  subtitleClassName?: string;
  actionText?: string;
  onClick?: () => void;
  actionButtonVariant?: ButtonVariations;
  actionDisabled?: boolean;
  buttonContainerClassName?: string;
  imageClassName?: string;
  className?: string;
}) => {
  return (
    <div
      className={`
        w-full flex flex-col
        justify-center items-center gap-6
        px-4 md:px-0 py-8 md:py-0
        ${className}
        `}
    >
      <div
        className={`ani-shake max-w-[176px] md:max-w-[248px] md:px-0 ${imageClassName}`}
      >
        {image}
      </div>

      <div className="max-w-[374px] flex flex-col items-center">
        <p
          className={`text-lg md:text-[20px] font-bold text-center ${titleClassName}`}
        >
          {title}
        </p>

        {subtitle && (
          <p
            className={`mt-2 text-center text-sm md:text-sm text-pry-dark-green-300/80 ${subtitleClassName}`}
          >
            {subtitle}
          </p>
        )}
      </div>

      {actionText && (
        <div className={`w-full !max-w-[327px] ${buttonContainerClassName}`}>
          <Button
            text={actionText}
            onClick={onClick}
            type="button"
            className="w-full md:!py-[12px]"
            loading={false}
            disabled={actionDisabled}
            variation={actionButtonVariant}
          />
        </div>
      )}
    </div>
  );
};
